// extracted by mini-css-extract-plugin
export const sectionTipsAndAdviceWidget = "tipsAndAdviceWidget-module--sectionTipsAndAdviceWidget--2OHPR";
export const sectionCTA = "tipsAndAdviceWidget-module--sectionCTA--3FzdS";
export const ctalink = "tipsAndAdviceWidget-module--ctalink--2x3_S";
export const richtext = "tipsAndAdviceWidget-module--richtext--3xd8x";
export const sectionMobileCTA = "tipsAndAdviceWidget-module--sectionMobileCTA--3F0pn";
export const sectionMobileCTA__blogs = "tipsAndAdviceWidget-module--sectionMobileCTA__blogs--1oTmI";
export const sectionContent = "tipsAndAdviceWidget-module--sectionContent--1x65X";
export const listingWrap = "tipsAndAdviceWidget-module--listingWrap--e5Hz0";
export const listingItem = "tipsAndAdviceWidget-module--listingItem--2cykS";
export const itemImage = "tipsAndAdviceWidget-module--itemImage--3s6ew";
export const itemImageBackground = "tipsAndAdviceWidget-module--itemImageBackground--2Iw2g";
export const itemImageBackgroundCover = "tipsAndAdviceWidget-module--itemImageBackgroundCover--26s7w";
export const itemDetails = "tipsAndAdviceWidget-module--itemDetails--39d1x";
export const iconsBar = "tipsAndAdviceWidget-module--iconsBar--17-SK";
export const itemCta = "tipsAndAdviceWidget-module--itemCta--2364C";
export const categoryPreview = "tipsAndAdviceWidget-module--categoryPreview--21CeA";
export const listWrapper = "tipsAndAdviceWidget-module--listWrapper--2Bniy";
export const itemWrap = "tipsAndAdviceWidget-module--itemWrap--3fb2H";
export const imageWrap = "tipsAndAdviceWidget-module--imageWrap--3UWTb";
export const contentTitle = "tipsAndAdviceWidget-module--contentTitle--1iz_W";
export const contentTextWrap = "tipsAndAdviceWidget-module--contentTextWrap--y8I3q";
export const description = "tipsAndAdviceWidget-module--description--11mLq";